import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  chatInput__wrapper: () => ({
    height: 'auto',
    display: 'grid',
    alignSelf: 'end',
    padding: '5px 16px 5px 16px',
    borderRadius: 12,
    background: 'white',
    transition: '0.2s background',
  }),
  chatInput__content: {
    display: 'grid',
    gridTemplateColumns: '1fr auto auto',
    alignItems: 'center',
    gap: 2,
  },
  chatInput: {
    display: 'grid',
    width: 650,
    margin: '0 auto',
  },
  chatInput__input: () => ({
    border: 'none',
    outline: 'none',
    fontSize: 16,
    fontWeight: 'normal !important',
    whiteSpace: 'pre-wrap',
    verticalAlign: 'middle',
    overflowY: 'scroll',
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
    cursor: 'text',
    resize: 'none',
    background: 'transparent',
    transition: '0.2s color',

    '&::-webkit-scrollbar': {
      display: 'none',
    },

    '&::placeholder': {
      color: '#a2acb4',
    },
  }),
  chatInput__icon: () => ({
    color: '#a2acb4',
    transition: '0.2s color',
  }),
  chatInput__header: {
    display: 'grid',
    paddingLeft: 12,
  },
  chatInput__hiddenModeTitle: () => ({
    gridColumn: '1, -1',
    fontStyle: 'italic',
    fontSize: 13,
    color: ' #9EA6AE',
    transition: '0.2s all',
    userSelect: 'none',
  }),

  message_wrap: {
    display: 'flex',
    gap: 12,
    justifyContent: 'space-between',
    width: '100%',
  },
  message: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
    padding: '4px 12px',
  },
  message__userTitle: {
    fontSize: 14,
    color: '#65aadd',
    fontWeight: 500,
  },
  message__userAddress: {
    fontSize: 12,
    opacity: 0.5,
  },
  message__userText: {
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '20px',
    display: 'flex',
    gap: 4,
  },
  message__icon: {
    opacity: 0.7,
  },
});
